/* eslint-disable max-lines */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
import React from 'react';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import axios from 'axios';
import { updateQueryStringParameter, deepCopyObject, loadScript } from 'mazey';
import {
  Upload,
  message,
  List,
  Avatar,
  Select,
  Form,
  Input,
  Button,
  Modal,
  Switch,
  Spin,
  Tooltip,
  Space,
  Typography
} from 'antd';
import { InboxOutlined, LockOutlined, InfoOutlined } from '@ant-design/icons';
import { ossApi } from './api/m';
import { formatRelative } from 'date-fns';
import { zhCN } from 'date-fns/locale';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { pageTitle } from '../../config/page-settings.js';
import { wGetLocalStorage, wSetLocalStorage } from '../../utils/utils.js';
import Login, { getAccessToken } from '../../components/login/index.jsx';
const { Dragger } = Upload;
const { Option } = Select;
const { Paragraph } = Typography;
const formConfsDefault = {
  ossId: 0,
  ossName: '',
  region: '',
  accessKeyId: '',
  accessKeySecret: '',
  bucket: '',
  cdnDomain: '',
  ossIsPublic: false
};
const defaultTarget = 'asset/default/';
const localOssTarget = wGetLocalStorage('ossTarget');

class OSSUpload extends React.Component {
  constructor (props) {
    super(props);
    // console.log('i am children!');
    this.changeTarget = this.changeTarget.bind(this);
    this.updateUrlTarget = this.updateUrlTarget.bind(this);
    this.changeFormConfs = this.changeFormConfs.bind(this);
    this.submitFormConfs = this.submitFormConfs.bind(this);
    this.cancelSubmitFormConfs = this.cancelSubmitFormConfs.bind(this);
    this.showFormConfs = this.showFormConfs.bind(this);
    this.getfilesize = this.getfilesize.bind(this);
    this.getAssets = this.getAssets.bind(this);
    this.selectOSSConf = this.selectOSSConf.bind(this);
    this.getOSSConfs = this.getOSSConfs.bind(this);
    this.changeIsOnlyMyselfAssets = this.changeIsOnlyMyselfAssets.bind(this);
    this.saveLocalTarget = this.saveLocalTarget.bind(this);
    this.removeAsset = this.removeAsset.bind(this);
    this.verTarget = this.verTarget.bind(this);
    this.init = this.init.bind(this);
    const addAsset = (this.addAsset = this.addAsset.bind(this));
    this.state = {
      draggerProps: {
        name: 'file',
        multiple: true,
        action: ossApi.upload,
        showUploadList: false,
        onChange (info) {
          const { status, uid, name, percent } = info.file;
          if (status === 'uploading') {
            message.loading({
              content: `${name} 上传中${percent === 100 ? '...' : `，进度 ${percent.toFixed(2)}%`}`,
              key: uid,
              duration: 0
            });
          }
          if (status !== 'uploading') {
            message.warn({ content: `${name} 上传出现未知情况！`, key: uid, duration: 2 });
          }
          if (status === 'done') {
            message.success({ content: `${name} 上传成功！`, key: uid, duration: 2 });
            addAsset(info.file.response.data);
          } else if (status === 'error') {
            message.error({ content: `${name} 上传失败！`, key: uid, duration: 2 });
          }
        }
      },
      ossConfs: [],
      ossConfsSelectedValue: '',
      formConfs: deepCopyObject(formConfsDefault),
      formConfsShow: false,
      ossTarget: localOssTarget || defaultTarget,
      assets: [],
      isOnlyMyselfAssets: false,
      copied: false,
    };
  }

  // init
  init () {
    this.getAssets();
    this.getOSSConfs();
  }

  // 获取配置列表
  getOSSConfs ({ type = '' } = {}) {
    // type: new / 新创建
    return axios.get(`${ossApi.newOssConfsQuery}?token=${getAccessToken()}`).then(({ data: res }) => {
      const {
        data: { ossConfs }
      } = res;
      let mazeyOssConfsSelectedValue;
      if (type !== 'new') {
        mazeyOssConfsSelectedValue = wGetLocalStorage('ossConfsSelectedValue');
      }
      // 配置渲染完成再指定选中值
      this.setState({ ossConfs }, () => {
        // console.log('ossConfs', ossConfs);
        // console.log('mazeyOssConfsSelectedValue', mazeyOssConfsSelectedValue);
        if (ossConfs.length) {
          if (!ossConfs.some(({ ossId }) => ossId === Number(mazeyOssConfsSelectedValue))) {
            mazeyOssConfsSelectedValue = undefined;
          }
          this.setState({ ossConfsSelectedValue: mazeyOssConfsSelectedValue || ossConfs[0].ossId }, () =>
            this.getAssets()
          );
        }
      });
    });
  }

  // 获取资源列表
  getAssets () {
    if (!this.state.ossConfsSelectedValue) return;
    return axios.get(`${ossApi.query}?oss_id=${this.state.ossConfsSelectedValue}&limit=30`).then(({ data: res }) => {
      const {
        data: { assets }
      } = res;
      if (!assets.length) {
        assets.push({
          createAt: '2020-10-09T10:47:45.000Z',
          fileName: '新手上路.jpeg',
          fileSize: 82152,
          fileType: 'image/jpeg',
          ossLink: 'https://www.example.com/asset/新手上路.jpeg',
          showLink: 'https://www.example.com/asset/新手上路.jpeg',
          target: 'asset/'
        });
      }
      this.setState({ assets });
    });
  }

  // 删除资源
  removeAsset ({ assetId, fileName }) {
    axios
      .post(`${ossApi.remove}`, {
        asset_id: assetId
      })
      .then(({ data }) => {
        if (data.ret === 0) {
          const assets = this.state.assets.filter((v) => v.assetId !== assetId);
          this.setState({ assets });
          message.success({ content: `${fileName} 上传记录删除成功！`, duration: 2 });
        }
      })
      .catch(console.error);
  }

  // 上传成功资源新增
  addAsset (asset) {
    const assets = deepCopyObject(this.state.assets);
    assets.unshift(asset);
    this.setState({ assets });
  }

  // 修改路径
  changeTarget (e) {
    const value = e.target.value;
    this.setState({ ossTarget: value });
  }

  // 保存路径
  saveLocalTarget () {
    this.verTarget().then(() => {
      wSetLocalStorage('ossTarget', this.state.ossTarget);
      message.success({ content: `保存 ${this.state.ossTarget} 至本地`, duration: 2 });
      window._hmt && window._hmt.push(['_trackEvent', 'oss', 'save', 'path', this.state.ossTarget]);
    });
  }

  // 更新链接中的 target
  async updateUrlTarget () {
    // 验证 ossTarget 合法性 / 不能为空 / 结尾需要 “/” / 开头不需要 "/"
    await this.verTarget();
    const oUrl = this.state.draggerProps.action;
    let target = this.state.ossTarget;
    if (this.state.ossConfsSelectedValue === 6) {
      target = 'rok-tw-excel/';
    }
    let nUrl = updateQueryStringParameter(oUrl, 'target', target);
    nUrl = updateQueryStringParameter(nUrl, 'oss_id', this.state.ossConfsSelectedValue);
    // const user_fingerprint = this.getFingerLocal();
    // if (user_fingerprint) {
    //   nUrl = updateQueryStringParameter(nUrl, 'user_fingerprint', user_fingerprint);
    // }
    const draggerProps = Object.assign(this.state.draggerProps, { action: nUrl });
    this.setState({ draggerProps });
    return true;
  }

  // 验证路径的有效性
  verTarget () {
    let target = this.state.ossTarget;
    let ok;
    const status = new Promise((resolve) => (ok = resolve));
    if (!target || target === '/') {
      target = defaultTarget;
      message.warn({ content: `暂不建议把图片上传到更目录下，已为你重置为默认路径：${target}`, duration: 2 });
      // return false;
    }
    if (target.startsWith('/')) {
      target = target.slice(1);
      message.warn({ content: `上传路径不能以字符 / 开头，已为您去除：${target}`, duration: 2 });
    }
    if (!target.endsWith('/')) {
      target += '/';
      message.warn({ content: `上传路径必须以字符 / 结尾，已为您补上：${target}`, duration: 2 });
    }
    this.setState({ ossTarget: target }, () => ok(true));
    return status;
  }

  // 显示 OSS 配置
  showFormConfs () {
    this.setState({ formConfsShow: true });
  }

  // 修改 OSS 配置
  changeFormConfs (attr, e) {
    let value;
    if (attr === 'ossIsPublic') {
      value = e;
    } else {
      value = e.target.value;
    }
    const nFormConfs = Object.assign(this.state.formConfs, { [attr]: value });
    this.setState({ formConfs: nFormConfs });
  }

  // 提交 OSS 配置
  submitFormConfs () {
    const c = this.state.formConfs;
    axios
      .post(`${ossApi.newOssConfsCreate}`, {
        ossName: c.ossName,
        region: c.region,
        accessKeyId: c.accessKeyId,
        accessKeySecret: c.accessKeySecret,
        bucket: c.bucket,
        cdnDomain: c.cdnDomain,
        userName: pageTitle
      })
      .then(({ data: res }) => {
        const { ret } = res;
        if (ret === 0) {
          this.getOSSConfs({ type: 'new' });
          this.cancelSubmitFormConfs();
          message.success({ content: '成功', duration: 3 });
        } else {
          message.error({ content: res.message, duration: 3 });
        }
      });
  }

  // 取消修改 OSS 配置
  cancelSubmitFormConfs () {
    this.setState({ formConfsShow: false, formConfs: deepCopyObject(formConfsDefault) });
  }

  // 语义化文件大小
  getfilesize (size) {
    // 把字节转换成正常文件大小
    if (!size) return '';
    const num = 1024.0; // byte
    if (size < num) {
      return size + ' B';
    }
    if (size < Math.pow(num, 2)) {
      return (size / num).toFixed(2) + ' KB';
    } // kb
    if (size < Math.pow(num, 3)) {
      return (size / Math.pow(num, 2)).toFixed(2) + ' MB';
    } // M
    if (size < Math.pow(num, 4)) {
      return (size / Math.pow(num, 3)).toFixed(2) + ' G';
    } // G
    return (size / Math.pow(num, 4)).toFixed(2) + ' T'; // T
  }

  // 选择配置
  selectOSSConf (ossConfsSelectedValue) {
    this.setState({ ossConfsSelectedValue }, this.getAssets.bind(this));
    if (ossConfsSelectedValue) wSetLocalStorage('ossConfsSelectedValue', ossConfsSelectedValue);
  }

  // 查看自己开关
  changeIsOnlyMyselfAssets (checked) {
    this.setState({
      isOnlyMyselfAssets: checked
    });
  }

  render () {
    return (
      <Login init={this.init}>
        <ol className="breadcrumb pull-right">
          <li className="breadcrumb-item">首页</li>
          <li className="breadcrumb-item">静态资源</li>
          <li className="breadcrumb-item active">OSS 上传</li>
        </ol>
        <h1 className="page-header">
          阿里云 OSS 上传 <small></small>
        </h1>
        <div className="row">
          <div className="col-lg-12">
            <Panel>
              <PanelHeader>OSS</PanelHeader>
              <PanelBody className="_panel-form">
                <div className="note note-yellow m-b-15">
                  <div className="note-icon f-s-20">
                    <i className="fa fa-lightbulb fa-2x"></i>
                  </div>
                  <div className="note-content">
                    <h4 className="m-t-5 m-b-5 p-b-2">提示</h4>
                    <ul className="m-b-5 p-l-25">
                      <li>
                          上传的最大文件尺寸是 <strong>2 MB</strong>。
                      </li>
                      <li>上传文件类型没有限制。</li>
                      <li>
                        <strong>上传路径</strong>可修改，但是不能是根目录，例如：asset/default/。
                      </li>
                      <li>
                        <strong>新增</strong>&gt;<strong>域名</strong>
                          建议是完整域名前缀，以便真实访问和使用，例如：https://www.example.com/。
                      </li>
                      {/* <li><strong>编辑</strong>和<strong>删除</strong>属于敏感操作，暂不开放。</li> */}
                      {/* <li>Uploaded files will be deleted automatically after <strong>5 minutes</strong>.</li> */}
                    </ul>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-10">
                    <Form layout="inline" name="oss_upload_form">
                      <Form.Item label="OSS 配置：">
                        <Select
                          value={this.state.ossConfsSelectedValue}
                          style={{ width: 160 }}
                          onChange={this.selectOSSConf}
                        >
                          {this.state.ossConfs &&
                              this.state.ossConfs.length &&
                              this.state.ossConfs.map((item) => (
                                <Option value={item.ossId} key={item.ossId}>
                                  {item.ossName}
                                </Option>
                              ))}
                        </Select>
                        <Button className="m-l-5" onClick={this.showFormConfs} htmlType="button" disabled>
                            编辑
                        </Button>
                        <Button className="m-l-5" onClick={this.showFormConfs} htmlType="button" disabled>
                            删除
                        </Button>
                        <Button className="m-l-5" onClick={this.showFormConfs} htmlType="button">
                            新增配置
                        </Button>
                      </Form.Item>
                      <Form.Item label="上传路径：">
                        <Input
                          style={{ width: '160px' }}
                          placeholder="请输入上传路径"
                          disabled={this.state.ossConfsSelectedValue === 6}
                          value={this.state.ossConfsSelectedValue === 6 ? 'rok-tw-excel/' : this.state.ossTarget}
                          onChange={this.changeTarget}
                        />
                        <Button className="m-l-5" onClick={this.saveLocalTarget} htmlType="button">
                            保存路径
                        </Button>
                      </Form.Item>
                      {/* <Form.Item
                        label="只看本机上传："
                        rules={[
                          {
                            required: false,
                          },
                        ]}
                      >
                        <Switch
                          checkedChildren="是"
                          unCheckedChildren="否"
                          checked={this.state.isOnlyMyselfAssets}
                          onChange={this.changeIsOnlyMyselfAssets}
                        />
                      </Form.Item> */}
                    </Form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <Dragger {...this.state.draggerProps} beforeUpload={this.updateUrlTarget}>
                      <p className="ant-upload-drag-icon">
                        <InboxOutlined />
                      </p>
                      <p className="ant-upload-text">Click or drag file to this area to upload</p>
                      <p className="ant-upload-hint">
                          Support for a single or bulk upload. Strictly prohibit from uploading company data or other
                          band files
                      </p>
                    </Dragger>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <List
                      itemLayout="horizontal"
                      dataSource={this.state.assets}
                      renderItem={(item) => (
                        <List.Item>
                          <List.Item.Meta
                            avatar={
                              <Avatar
                                src={
                                  item.fileSize <= 10 * 1024 && item.fileType.includes('image') ? item.showLink : ''
                                }
                              />
                            }
                            title={
                              <>
                                {item.fileName}
                                {item.assetId ? (
                                  <Button
                                    danger
                                    className="m-l-5"
                                    htmlType="button"
                                    size="small"
                                    onClick={() => this.removeAsset(item)}
                                  >
                                      删除
                                  </Button>
                                ) : (
                                  ''
                                )}
                              </>
                            }
                            description={
                              <span>
                                  访问地址:{' '}
                                <a href={item.showLink} target="_blank" rel="noopener noreferrer" className="newline">
                                  {item.showLink}
                                </a>
                                {/* 复制按钮 */}
                                <CopyToClipboard
                                  text={item.showLink}
                                  onCopy={() =>
                                    message.success({ content: `${item.showLink} 已复制至剪贴板`, duration: 2 })
                                  }
                                >
                                  <Button className="m-l-5" htmlType="button" size="small">
                                      复制
                                  </Button>
                                </CopyToClipboard>
                                <br />
                                  源站地址:{' '}
                                <a href={item.ossLink} target="_blank" rel="noopener noreferrer" className="newline">
                                  {item.ossLink}
                                </a>
                                <br />
                                  文件类型: {item.fileType}
                                <br />
                                  文件尺寸: {this.getfilesize(item.fileSize)}
                                <br />
                                  上传时间: {formatRelative(new Date(item.createAt), new Date(), { locale: zhCN })}
                              </span>
                            }
                          />
                        </List.Item>
                      )}
                    />
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </div>
        </div>
        {/* 新增配置 */}
        <Modal
          visible={this.state.formConfsShow}
          title="OSS 配置"
          okText="确认"
          cancelText="取消"
          onCancel={this.cancelSubmitFormConfs}
          onOk={this.submitFormConfs}
          maskClosable={false}
          // style={{ zIndex: 1100 }}
        >
          <Form
            labelCol={{
              span: 6
            }}
            wrapperCol={{
              span: 18
            }}
            layout="horizontal"
          >
            <Form.Item label="配置名">
              <Input
                placeholder="必填，例如：图片上传、静态资源、我的OSS"
                value={this.state.formConfs.ossName}
                onChange={this.changeFormConfs.bind(this, 'ossName')}
              />
            </Form.Item>
            <Form.Item label="region">
              <Input
                placeholder="必填，例如：oss-cn-shanghai"
                value={this.state.formConfs.region}
                onChange={this.changeFormConfs.bind(this, 'region')}
              />
            </Form.Item>
            <Form.Item label="accessKeyId">
              <Input
                placeholder="必填，例如：LLcDSSzCASs..."
                value={this.state.formConfs.accessKeyId}
                onChange={this.changeFormConfs.bind(this, 'accessKeyId')}
              />
            </Form.Item>
            <Form.Item label="accessKeySecret">
              <Input
                placeholder="必填，例如：EEsOpFFQ97g..."
                value={this.state.formConfs.accessKeySecret}
                onChange={this.changeFormConfs.bind(this, 'accessKeySecret')}
              />
            </Form.Item>
            <Form.Item label="bucket">
              <Input
                placeholder="必填，例如：my-oss"
                value={this.state.formConfs.bucket}
                onChange={this.changeFormConfs.bind(this, 'bucket')}
              />
            </Form.Item>
            <Form.Item label="域名">
              <Input
                placeholder="必填，访问地址前缀，例如：https://www.d.cn/"
                value={this.state.formConfs.cdnDomain}
                onChange={this.changeFormConfs.bind(this, 'cdnDomain')}
              />
            </Form.Item>
            <Form.Item label="是否公开" hidden={true}>
              <Switch
                checked={this.state.formConfs.ossIsPublic}
                onChange={this.changeFormConfs.bind(this, 'ossIsPublic')}
              />
            </Form.Item>
          </Form>
        </Modal>
      </Login>
    );
  }
}

export default OSSUpload;
